import { startOfMonth } from 'date-fns';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type FromDate = Date;
type ToDate = Date;
type IsLoad = boolean;

// ----------------------- actions -------------------------------------
const SET_IS_LOAD_CAMPAIGNS_REPORT = 'SET_IS_LOAD_CAMPAIGNS_REPORT';
const SET_DATES_CAMPAIGNS_REPORT = 'SET_DATES_CAMPAIGNS_REPORT';

interface PayloadTypes {
    [SET_IS_LOAD_CAMPAIGNS_REPORT]: IsLoad;
    [SET_DATES_CAMPAIGNS_REPORT]: { from: FromDate; to: ToDate };
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setLoadCampaignsReport = ActionCreator(SET_IS_LOAD_CAMPAIGNS_REPORT);
export const setCampaignsReportDates = ActionCreator(SET_DATES_CAMPAIGNS_REPORT);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface CampaignsReportState {
    isLoad: IsLoad;
    from: FromDate;
    to: ToDate;
}

const CAMPAIGNS_REPORT_INITIAL_STATE: CampaignsReportState = {
    isLoad: false,
    from: startOfMonth(new Date()),
    to: new Date(),
};

export default createReducer<CampaignsReportState, PayloadTypes>(CAMPAIGNS_REPORT_INITIAL_STATE, {
    [SET_DATES_CAMPAIGNS_REPORT]: (state, { payload }) => ({
        ...state,
        from: payload.from,
        to: payload.to,
    }),
    [SET_IS_LOAD_CAMPAIGNS_REPORT]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
